var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('h1',[_vm._v("This is an User page")]),_c('div',[_vm._v(_vm._s(_vm.$i18n.locale))]),_c('div',[_vm._v(_vm._s(_vm.$t('test')))])])}
var staticRenderFns = []

export { render, staticRenderFns }